import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UIState {
  siteName: string;
  logo: string;
  menus: any[];
  favicon: string;
}

const initialState: UIState = {
  siteName: '',
  logo: '',
  menus: [],
  favicon: '/favicon.ico'
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    loadUI(state) {
      // This action triggers the saga to load UI data
    },
    applyLoadedUI(state, action: PayloadAction<Partial<UIState>>) {
      Object.assign(state, action.payload);
    },
    updateUIValue(state, action: PayloadAction<Partial<UIState>>) {
      Object.assign(state, action.payload);
    }
  }
});

export const { loadUI, applyLoadedUI, updateUIValue } = uiSlice.actions;

export default uiSlice.reducer;